import { PostFormData } from 'types/post';

export const initialFormData: PostFormData = {
    message: '',
    attachments: [],
};

export const FORM_ID = 'create-comment-form';
